// The Mill Canvas — content model.
// Everything here is SYNTHETIC and illustrative. No real Mill people or data.

export const AVATARS = {
  volunteer: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHxkaXZlcnNlJTIwcHJvZmVzc2lvbmFsJTIwcG9ydHJhaXQlMjBoZWFkc2hvdHN8ZW58MHx8fHwxNzgzMzQzMDMzfDA&ixlib=rb-4.1.0&q=85&w=200&h=200&fit=crop",
  group_leader: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxkaXZlcnNlJTIwcHJvZmVzc2lvbmFsJTIwcG9ydHJhaXQlMjBoZWFkc2hvdHN8ZW58MHx8fHwxNzgzMzQzMDMzfDA&ixlib=rb-4.1.0&q=85&w=200&h=200&fit=crop",
  room_hirer: "https://images.unsplash.com/photo-1573497161161-c3e73707e25c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwzfHxkaXZlcnNlJTIwcHJvZmVzc2lvbmFsJTIwcG9ydHJhaXQlMjBoZWFkc2hvdHN8ZW58MHx8fHwxNzgzMzQzMDMzfDA&ixlib=rb-4.1.0&q=85&w=200&h=200&fit=crop",
  centre_admin: "https://images.unsplash.com/photo-1607990283143-e81e7a2c9349?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHw0fHxkaXZlcnNlJTIwcHJvZmVzc2lvbmFsJTIwcG9ydHJhaXQlMjBoZWFkc2hvdHN8ZW58MHx8fHwxNzgzMzQzMDMzfDA&ixlib=rb-4.1.0&q=85&w=200&h=200&fit=crop",
  trustee: "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHw1fHxkaXZlcnNlJTIwcHJvZmVzc2lvbmFsJTIwcG9ydHJhaXQlMjBoZWFkc2hvdHN8ZW58MHx8fHwxNzgzMzQzMDMzfDA&ixlib=rb-4.1.0&q=85&w=200&h=200&fit=crop",
};

export const PERSONAS = [
  {
    id: "volunteer",
    name: "Ava Whitmore",
    role: "Volunteer",
    avatar: AVATARS.volunteer,
    tagline: "Warm Space Host",
    authority: "May begin induction, complete the checklist, acknowledge the current policy and receive reminders.",
  },
  {
    id: "group_leader",
    name: "Grace Okafor",
    role: "Group Leader",
    avatar: AVATARS.group_leader,
    tagline: "Warm Space Wednesdays",
    authority: "May submit an activity return, capture observations and request a submission receipt.",
  },
  {
    id: "room_hirer",
    name: "Dawn Kelemen",
    role: "Room Hirer",
    avatar: AVATARS.room_hirer,
    tagline: "Sunrise Yoga (community group)",
    authority: "May make a room enquiry, view quoted terms and accept them — but cannot approve their own booking.",
  },
  {
    id: "centre_admin",
    name: "Priya Nair",
    role: "Centre Administrator",
    avatar: AVATARS.centre_admin,
    tagline: "Front-of-house & coordination",
    authority: "May check eligibility, quote, approve or refuse bookings, remind volunteers, raise invoices and sign approvals.",
  },
  {
    id: "trustee",
    name: "Alastair Finch",
    role: "Trustee / P&I Reviewer",
    avatar: AVATARS.trustee,
    tagline: "Prove & Improve oversight",
    authority: "May review activity returns and read the aggregate Prove & Improve view — never individual participant data.",
  },
];

export const personaById = (id) => PERSONAS.find((p) => p.id === id) || PERSONAS[0];

// Layer legend — every action in the canvas is tagged with one of these.
export const LAYERS = {
  ordinary: {
    key: "ordinary",
    label: "Ordinary tool",
    hint: "Belongs in normal charity software (CRM, booking, finance, comms, docs).",
    className: "bg-mill-alt text-mill-muted border-stone-300",
  },
  self_service: {
    key: "self_service",
    label: "Web self-service",
    hint: "A browser-accessible step that reduces friction — no email chain needed.",
    className: "bg-[#E8F0EA] text-mill-moss border-[#C9DBCD]",
  },
  governed: {
    key: "governed",
    label: "Future governed action",
    hint: "Where a KATLAS receipt could add custody, authority or proof of completion.",
    className: "bg-[#FEF3C7] text-[#B45309] border-[#FDE68A]",
  },
};

// Which persona may perform which action (authority model).
const AUTHORITY = {
  "induction.acknowledge": ["volunteer"],
  "induction.toggle": ["volunteer"],
  "induction.remind": ["centre_admin"],
  "induction.sign": ["centre_admin"],
  "room_hire.enquire": ["room_hirer"],
  "room_hire.check": ["centre_admin"],
  "room_hire.quote": ["centre_admin"],
  "room_hire.approve": ["centre_admin"],
  "room_hire.invoice": ["centre_admin"],
  "room_hire.sign": ["centre_admin"],
  "activity_return.submit": ["group_leader"],
  "activity_return.review": ["trustee"],
  "activity_return.sign": ["group_leader"],
};

export const canPerform = (personaId, action) => (AUTHORITY[action] || []).includes(personaId);
export const allowedRoleNames = (action) =>
  (AUTHORITY[action] || []).map((id) => personaById(id).role).join(" or ");

export const JOURNEYS = [
  {
    id: "induction",
    route: "/journey/induction",
    icon: "ClipboardCheck",
    title: "Volunteer induction & policy acknowledgement",
    chain: ["Volunteer", "Volunteer Lead", "Centre Administrator"],
    summary:
      "A new volunteer is invited, works through role-relevant guidance and a checklist, and acknowledges the current policy version.",
    outcome: "Less chasing, a clear completion state, and a safer, better-supported volunteer.",
    anatomy: [
      { element: "Person / organisation", detail: "Ava Whitmore, a new Warm Space Host volunteer." },
      { element: "Role & authority", detail: "The volunteer may acknowledge; the volunteer lead invites; the centre administrator can remind and evidence completion." },
      { element: "System of record", chips: ["Volunteer CRM", "Document hub", "Comms tool"], detail: "The induction record, policy pack and reminders live in ordinary tools." },
      { element: "Action / workflow", detail: "Invitation → role guidance → checklist → policy acknowledgement → completion state.", layer: "self_service" },
      { element: "Evidence boundary", private: ["Volunteer name & contact", "Personal record", "Which centre they attend"], receipt: ["A named role completed a named policy version", "Checklist marked complete"] },
      { element: "Outcome", detail: "A visible completion state instead of an inbox thread — and optional proof that a role completed a named induction version." },
    ],
    governed: {
      title: "Proof of induction completion",
      statement: "A receipt could prove a named role completed a named version of the induction material — without exposing the volunteer's personal record.",
    },
  },
  {
    id: "room_hire",
    route: "/journey/room-hire",
    icon: "DoorOpen",
    title: "Room hire",
    chain: ["Hirer", "Centre Administrator", "Finance / Building Lead"],
    summary:
      "A community group enquires about a room; the administrator checks eligibility, quotes terms, approves the booking and tracks invoice status.",
    outcome: "Clearer ownership of the booking pipeline and fewer back-and-forth emails to confirm terms.",
    anatomy: [
      { element: "Person / organisation", detail: "Sunrise Yoga, a fictional community group, wants a weekly slot." },
      { element: "Role & authority", detail: "The hirer may enquire and accept terms but cannot approve their own booking; the administrator approves; finance handles the invoice." },
      { element: "System of record", chips: ["Booking tool", "Finance tool", "Comms tool"], detail: "Availability, quotes and invoices stay in the normal booking and finance systems." },
      { element: "Action / workflow", detail: "Enquiry → eligibility & availability → quote → approval & terms → invoice / payment status.", layer: "self_service" },
      { element: "Evidence boundary", private: ["Hirer contact details", "Quote amount", "Payment status"], receipt: ["Authorised booking approval", "Acceptance of terms"] },
      { element: "Outcome", detail: "A self-service enquiry with a visible status — and optional proof that an authorised person approved the booking and terms were accepted." },
    ],
    governed: {
      title: "Proof of authorised approval",
      statement: "A receipt could confirm an authorised booking approval and acceptance of terms — without exposing the hirer's contact or payment data.",
    },
  },
  {
    id: "activity_return",
    route: "/journey/activity-return",
    icon: "LineChart",
    title: "Group activity return & Prove and Improve",
    chain: ["Group Leader", "Centre Team", "Trustee / P&I Reviewer"],
    summary:
      "After a session, a group leader files a lightweight return; aggregate evidence flows to a Prove & Improve reporting view for trustees.",
    outcome: "Stronger Prove & Improve evidence with no participant data exposed.",
    anatomy: [
      { element: "Person / organisation", detail: "Grace Okafor, who leads Warm Space Wednesdays." },
      { element: "Role & authority", detail: "The group leader submits the return; the centre team collates; a trustee reviews aggregate evidence only." },
      { element: "System of record", chips: ["Activity log", "Reporting view", "CRM"], detail: "Returns are collated into an aggregate reporting view; raw participant data never enters it." },
      { element: "Action / workflow", detail: "Activity completed → attendance & feedback return → observation captured → aggregate evidence → trustee review.", layer: "self_service" },
      { element: "Evidence boundary", private: ["Participant records", "Individual feedback", "Any incident detail"], receipt: ["A return was submitted", "Aggregate attendance band"] },
      { element: "Outcome", detail: "A single lightweight form feeds Prove & Improve — and optionally proves a return was submitted, without ever exposing who attended." },
    ],
    governed: {
      title: "Proof a return was submitted",
      statement: "A receipt could prove an activity return was submitted for reporting — without exposing any participant or attendee data.",
    },
  },
  {
    id: "community_guide",
    route: "/journey/community-guide",
    icon: "Compass",
    title: "Community information & service navigation",
    chain: ["Resident / Visitor / Volunteer", "Mill Guide", "Approved resource or future authenticated pathway"],
    summary:
      "A person asks a natural-language question and is guided to the correct approved resource — with a visible source, owner and review date, and a clear next action.",
    outcome: "Current information found in seconds, not email chains — with ownership, version control and human accountability retained.",
    anatomy: [
      { element: "Person / organisation", detail: "A resident, visitor, volunteer, group leader or partner with a question." },
      { element: "Role & authority", detail: "The Mill owns its content; named roles draft, approve, publish, amend or retire it. The Guide only surfaces approved current content — it decides nothing about people." },
      { element: "System of record", chips: ["Content hub", "Website", "Publisher identity"], detail: "Each answer is grounded in an owned content object with an inspectable metadata record." },
      { element: "Action / workflow", detail: "Ask → grounded answer with source, owner & review date → route to the right page, form, contact or future sign-in.", layer: "self_service" },
      { element: "Evidence boundary", private: ["Whether YOU are personally entitled", "Your account / voucher / claim status", "Any personal record"], receipt: ["That content was published", "That content was reviewed on a date", "That a policy version was acknowledged"] },
      { element: "Outcome", detail: "Public knowledge is easy to find; private entitlement is proven separately behind a future secure sign-in; consequential actions stay with the right authority." },
    ],
    governed: {
      title: "Proof of publication & review (future)",
      statement: "A receipt could prove that a named role published or reviewed a named version of content on a given date — using an organisational publisher identity, not a per-person wallet.",
    },
  },
  {
    id: "onboarding",
    route: "/journey/onboarding",
    icon: "UserPlus",
    title: "Role-based onboarding",
    chain: ["Centre Administrator", "Invitation & synthetic wallet", "Role-aware volunteer"],
    summary:
      "An administrator invites a person into a role; they redeem a one-time link, get a synthetic Mill wallet, complete onboarding, then see only permitted services and can start structured role-to-role requests.",
    outcome: "The right person gets the right pathway — and the administrator sees progress without chasing email.",
    anatomy: [
      { element: "Person / organisation", detail: "A prospective volunteer invited into a defined role by a Centre Administrator." },
      { element: "Role & authority", detail: "The invitation grants access to an onboarding pathway — not permanent authority. Role authority activates in the sandbox only after onboarding." },
      { element: "System of record", chips: ["CRM", "Managed wallet", "Invitation register"], detail: "Invitations, wallet workspace and onboarding progress live in ordinary tools; the wallet is a synthetic managed placeholder." },
      { element: "Action / workflow", detail: "Invite → one-time link → redeem → synthetic wallet → questionnaire & induction → role-aware dashboard → structured request.", layer: "self_service" },
      { element: "Evidence boundary", private: ["The person's questionnaire answers", "Whether they've been formally approved", "Any real identity / contact data"], receipt: ["A role completed a named induction version", "A structured request reached completion"] },
      { element: "Outcome", detail: "A realistic onboarding that maps cleanly to a future KATLAS managed wallet — but creates no real wallet, key or personal record here." },
    ],
    governed: {
      title: "Completion record (simulated)",
      statement: "Completing induction or a request produces an illustrative completion record marked 'Simulated'. It is not called a cryptographic receipt until a real KATLAS test node signs it.",
    },
  },
];

export const journeyById = (id) => JOURNEYS.find((j) => j.id === id);

export const STAGES = [
  { n: 0, title: "Synthetic design canvas", body: "Mock services, fictional records, visible 'illustrative' labels.", state: "active" },
  { n: 1, title: "Conventional tool selection", body: "CRM, booking, comms, finance and document requirements are clarified.", state: "future" },
  { n: 2, title: "Web / device practice layer", body: "Policy, guidance, forms and role dashboards accessible without email chains.", state: "future" },
  { n: 3, title: "One governed micro-journey", body: "A narrowly defined KATLAS-backed action via a thin server-side gateway.", state: "future" },
  { n: 4, title: "Reusable reference model", body: "Only if The Mill sees value: transferable patterns for community-hub partners.", state: "future" },
];

export const ADOPTION_STEPS = [
  { title: "Walk the three journeys", body: "Spend ten minutes as different roles. Notice where the day gets easier." },
  { title: "Mark what stays ordinary", body: "Decide which parts clearly belong in a CRM, booking or finance tool you already trust." },
  { title: "Keep the human parts human", body: "Protect the relationships and judgement that shouldn't be automated." },
  { title: "Try one governed step", body: "Pick a single handover where a receipt would genuinely reduce chasing or disputes." },
  { title: "Only then, decide", body: "Adopt, adapt or park it. Nothing here commits The Mill to anything." },
];

export const SUCCESS_QUESTIONS = [
  "Does this reduce real day-to-day friction?",
  "Which part belongs in the CRM or normal toolset?",
  "Which part should stay human?",
  "Is a web self-service step useful here?",
  "Does a KATLAS receipt add enough value to justify its complexity?",
  "What evidence would help The Mill prove and improve?",
];
